module.exports = __webpack_public_path__ + "static/media/Readability Icon.b6d56fb0.jpeg";